/*
 * @Descripttion: file content
 * @Author: zc
 * @Date: 2020-05-26 13:24:24
 * @LastEditors: zc
 * @LastEditTime: 2023-06-20 16:03:25
 */
import HeaderPaddingMain from '@/views/layout/HeaderPaddingMain.vue';
import UserCenterLayout from '@/views/layout/UserCenterLayout.vue';
var router = [{
  path: '/infoMaintain',
  component: HeaderPaddingMain,
  name: 'infoMaintain',
  meta: {
    title: '信息填写',
    noCache: true,
    moreFlag: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/user/InfoMaintain.vue');
    }
  }]
}, {
  path: '/improveInfo',
  component: HeaderPaddingMain,
  name: 'improveInfo',
  meta: {
    title: '完善学制',
    noCache: true,
    moreFlag: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/user/improveInfo.vue');
    }
  }]
}, {
  path: '/updatePwd',
  component: HeaderPaddingMain,
  name: 'updatePwd',
  meta: {
    title: '密码设置',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/user/UpdatePwd.vue');
    }
  }]
}, {
  path: '/choose',
  component: HeaderPaddingMain,
  name: 'choose',
  meta: {
    title: '系统选择',
    noCache: true,
    moreFlag: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/user/Choose.vue');
    }
  }]
}, {
  path: '/userCenter',
  component: UserCenterLayout,
  name: 'userCenter',
  meta: {
    title: '个人中心',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/user/UserCenter.vue');
    }
  }]
}, {
  path: '/userHelp',
  component: UserCenterLayout,
  name: 'userHelp',
  meta: {
    title: '帮助中心',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/user/UserHelp.vue');
    }
  }]
}];
export default router;